export interface TimelineEvent {
  time: string;
  title: string;
  desc: string;
}

export interface TopicComment {
  user: string;
  content: string;
  likes: number;
  time: string;
}

export interface TopicDetail {
  id: string;
  intro: string[];
  timeline: TimelineEvent[];
  comments: TopicComment[];
  related: string[];
}

export const topicDetails: Record<string, TopicDetail> = {
  "drama-finale-backlash": {
    id: "drama-finale-backlash",
    intro: [
      "收官当晚，播出平台的相关讨论量在两小时内翻了三倍。观众最集中的分歧出现在最后二十分钟：一部分人认为收束过于仓促，另一部分人则觉得留白恰恰是它的高级之处。",
      "从数据上看，站内短评数量在结局播出后迅速攀升，五星与三星评价几乎各占一半，这种“既爱又气”的分化，也让它成为今天榜单上当之无愧的第一名。",
    ],
    timeline: [
      { time: "昨晚 20:00", title: "大结局正式播出", desc: "收官集上线，讨论量在开播十分钟内突破峰值。" },
      { time: "昨晚 21:30", title: "关键剧情词条登上榜单", desc: "与结局相关的关键词开始密集出现，围观热度持续攀升。" },
      { time: "今日 09:00", title: "主创回应剪辑争议", desc: "制作方发布说明，解释了最终版取舍的创作逻辑。" },
      { time: "今日 12:00", title: "重刷党的二次解读", desc: "更多观众开始从细节里找伏笔，讨论从情绪转为考据。" },
    ],
    comments: [
      { user: "柠檬不酸", content: "追了三个月，最后一集心情太复杂了，但不得不承认导演很敢。", likes: 1862, time: "1 小时前" },
      { user: "后排围观", content: "我倒觉得结尾留白挺好，给观众自己补完空间，就是节奏确实快了。", likes: 974, time: "2 小时前" },
      { user: "追剧小分队", content: "已经开始二刷找细节了，前面埋的线其实都收回来了。", likes: 631, time: "3 小时前" },
    ],
    related: ["variety-name-scene", "new-drama-premiere", "song-cover-viral"],
  },
  "variety-name-scene": {
    id: "variety-name-scene",
    intro: [
      "流出的片段其实是录制过程中的一次临场反应，却因为剪辑节奏被放大成“名场面”。短视频平台的二次创作让这段内容在半天内获得了极高的转发量。",
      "不少网友表示，比起成片，自己更爱看这种未经修饰的即时反应，讨论也逐渐转向对综艺剪辑逻辑的思考。",
    ],
    timeline: [
      { time: "昨日 18:00", title: "花絮片段开始扩散", desc: "片段被多个账号转发，播放量快速累积。" },
      { time: "昨日 22:00", title: "相关词条冲上榜单", desc: "话题进入实时榜前十，评论区讨论转向剪辑节奏。" },
      { time: "今日 10:00", title: "节目组发布完整版", desc: "官方放出更长的录制内容，回应了此前的片段争议。" },
    ],
    comments: [
      { user: "沙发土豆", content: "完整版看下来其实很自然，是短片段太容易断章取义了。", likes: 1204, time: "2 小时前" },
      { user: "笑到扶墙", content: "那种真实的尴尬感才是最搞笑的，笑点全在反应里。", likes: 856, time: "4 小时前" },
      { user: "路人甲", content: "希望以后多放点录制花絮，比正片还好看。", likes: 402, time: "5 小时前" },
    ],
    related: ["drama-finale-backlash", "livestream-comeback", "award-season-talk"],
  },
  "livestream-comeback": {
    id: "livestream-comeback",
    intro: [
      "久违的开播让直播间在几分钟内涌入大量观众，弹幕密度一度达到近期高位。围观人群里既有老观众，也有被热度吸引来的新面孔。",
      "这次回归最受关注的变化，是内容结构从上货节奏转向了更多互动环节，讨论也因此集中在“直播还能怎么玩”上。",
    ],
    timeline: [
      { time: "昨晚 19:30", title: "直播间准时开播", desc: "开播瞬间同时在线人数快速冲高。" },
      { time: "昨晚 20:10", title: "互动环节成为高光", desc: "新增的观众连麦环节带动弹幕量显著上升。" },
      { time: "今日 08:00", title: "切片二次传播", desc: "精彩片段被二次剪辑，带动话题持续在榜。" },
    ],
    comments: [
      { user: "夜猫子选手", content: "好久没看到这么热闹的直播间了，氛围是真的回来了。", likes: 1420, time: "3 小时前" },
      { user: "理性围观", content: "内容调整挺明显的，互动多了，节奏也更松弛。", likes: 688, time: "5 小时前" },
      { user: "冲浪爱好者", content: "切片刷到好几遍，确实上头。", likes: 355, time: "6 小时前" },
    ],
    related: ["fitness-routine-viral", "variety-name-scene", "city-food-trend"],
  },
  "idol-airport-outfit": {
    id: "idol-airport-outfit",
    intro: [
      "一组路透让穿搭话题再次被翻出，网友从外套版型到配饰细节逐帧分析，甚至整理出同款清单。",
      "相比事件本身，大家更享受这种“全民找细节”的过程，热度因此保持在一个平稳区间。",
    ],
    timeline: [
      { time: "昨日 15:00", title: "路透图开始流传", desc: "图片在小范围传播后迅速被搬运扩散。" },
      { time: "昨日 20:00", title: "穿搭解析帖刷屏", desc: "同款讨论与搭配教程帖集中出现。" },
      { time: "今日 11:00", title: "热度趋于平稳", desc: "讨论从新鲜感转向常规分享。" },
    ],
    comments: [
      { user: "配色强迫症", content: "这一身的配色真的很稳，秋冬可以直接抄作业。", likes: 912, time: "4 小时前" },
      { user: "衣柜爆满", content: "配饰才是点睛之笔，细节控狂喜。", likes: 503, time: "6 小时前" },
    ],
    related: ["award-season-talk", "song-cover-viral", "livestream-comeback"],
  },
  "new-drama-premiere": {
    id: "new-drama-premiere",
    intro: [
      "首播当晚，站内短评数量就超过了同期剧集的平均值。观众的分歧主要集中在首集节奏：有人觉得铺垫扎实，也有人认为开局偏慢。",
      "选角是另一个高频讨论点，不少原著读者对照着角色设定逐条比对，讨论氛围整体理性。",
    ],
    timeline: [
      { time: "昨晚 20:00", title: "首集正式上线", desc: "开播后评分与短评数量同步走高。" },
      { time: "昨晚 22:30", title: "选角讨论集中爆发", desc: "原著读者与剧粉展开对照式讨论。" },
      { time: "今日 09:30", title: "口碑进入观察期", desc: "更多观众表示会继续追看第二集再下判断。" },
    ],
    comments: [
      { user: "追更中", content: "第一集信息量挺大的，感觉后面节奏会起来。", likes: 764, time: "3 小时前" },
      { user: "原著党", content: "选角比想象中贴，就是希望别改太多设定。", likes: 498, time: "5 小时前" },
    ],
    related: ["drama-finale-backlash", "variety-name-scene", "award-season-talk"],
  },
  "song-cover-viral": {
    id: "song-cover-viral",
    intro: [
      "一段现场翻唱被转发后迅速出圈，带动原曲重新回到热门歌单。评论区里，怀念与考古成了主旋律。",
      "有意思的是，这波热度的主角并不只是翻唱者，原曲本身也完成了“二次翻红”，形成了少见的三方共赢。",
    ],
    timeline: [
      { time: "前日 21:00", title: "现场片段流出", desc: "翻唱片段开始在音乐社区传播。" },
      { time: "昨日 12:00", title: "原曲重新上榜", desc: "原曲进入多个平台的热门歌单。" },
      { time: "今日 10:00", title: "二创潮出现", desc: "更多翻唱与演奏版本加入，话题持续延伸。" },
    ],
    comments: [
      { user: "循环播放", content: "原曲现在听还是好听，好歌真的会穿越时间。", likes: 1044, time: "4 小时前" },
      { user: "耳机党", content: "翻唱编曲改得挺巧，但原版的味道谁也替代不了。", likes: 621, time: "7 小时前" },
    ],
    related: ["drama-finale-backlash", "award-season-talk", "idol-airport-outfit"],
  },
  "city-food-trend": {
    id: "city-food-trend",
    intro: [
      "一条探店视频让街边小店排起长队，隐藏菜单成为打卡密码。有人晒出排队两小时的记录，也有人开始讨论“值不值得”。",
      "讨论的重点逐渐从“好不好吃”转向“网红店热度的保质期”，背后是大家对本地小店生态的关注。",
    ],
    timeline: [
      { time: "昨日 17:00", title: "探店视频发布", desc: "视频上线后播放量快速增长。" },
      { time: "今日 08:00", title: "线下开始排长队", desc: "到店人数明显增加，高峰期需等候较久。" },
      { time: "今日 13:00", title: "讨论转向理性", desc: "网友开始分享平替选择与错峰建议。" },
    ],
    comments: [
      { user: "干饭第一名", content: "隐藏菜单确实有点东西，但要排两小时我会犹豫。", likes: 588, time: "3 小时前" },
      { user: "本地老饕", content: "其实早上刚开门的时候人最少，错峰体验好很多。", likes: 733, time: "5 小时前" },
    ],
    related: ["fitness-routine-viral", "public-topic-debate", "city-food-trend"],
  },
  "public-topic-debate": {
    id: "public-topic-debate",
    intro: [
      "这个公共话题最初由几条转述引发，讨论很快从情绪表达转向具体建议，评论区出现了不少有建设性的补充。",
      "热度的小幅回落并不代表关注减少，更多人是选择先观察再发言，整体氛围趋于理性。",
    ],
    timeline: [
      { time: "前日 20:00", title: "话题被广泛转述", desc: "相关内容在多个平台同步扩散。" },
      { time: "昨日 15:00", title: "理性讨论占据主流", desc: "网友开始分享具体经验与建议。" },
      { time: "今日 11:00", title: "热度小幅回落", desc: "讨论进入沉淀期，关注者选择持续观察。" },
    ],
    comments: [
      { user: "有事说事", content: "比起情绪输出，我更想看到具体能落地的建议。", likes: 856, time: "4 小时前" },
      { user: "旁观记录", content: "难得看到评论区这么平和，理性讨论真的会更有效。", likes: 512, time: "6 小时前" },
    ],
    related: ["city-food-trend", "fitness-routine-viral", "new-drama-premiere"],
  },
  "fitness-routine-viral": {
    id: "fitness-routine-viral",
    intro: [
      "一份看似完美的作息表被大量转发，不少人开始照着执行，也有人质疑它在现实里很难长期坚持。",
      "正反两方的讨论其实指向同一个问题：自律方法该被当作模板，还是只适合被参考？",
    ],
    timeline: [
      { time: "昨日 09:00", title: "作息表被转发", desc: "相关内容在生活类社群中快速传播。" },
      { time: "昨日 21:00", title: "模仿与质疑同时出现", desc: "执行派与质疑派展开讨论。" },
      { time: "今日 12:00", title: "转向方法论讨论", desc: "更多网友分享适合自己的调整方式。" },
    ],
    comments: [
      { user: "早起失败者", content: "计划是好的，但每个人节奏不一样，硬套肯定崩。", likes: 690, time: "3 小时前" },
      { user: "慢慢来", content: "我按它改了两条，坚持三周了，效果还不错。", likes: 447, time: "6 小时前" },
    ],
    related: ["livestream-comeback", "city-food-trend", "public-topic-debate"],
  },
  "award-season-talk": {
    id: "award-season-talk",
    intro: [
      "年度奖项入围名单陆续放出，名单公布的瞬间就成了热点。网友立刻开始做预测、盘点与拉票式讨论。",
      "相比结果，更多人享受的是复盘过去一年作品的过程，话题尾部的席位因此被迅速补位。",
    ],
    timeline: [
      { time: "今日 10:00", title: "入围名单开始公布", desc: "首批名单放出后讨论快速升温。" },
      { time: "今日 12:30", title: "预测帖集中出现", desc: "网友开始制作各类预测与盘点。" },
      { time: "今日 15:00", title: "话题补位进榜", desc: "进入实时榜尾部，热度仍在爬升。" },
    ],
    comments: [
      { user: "看剧专业户", content: "每年这个时候最有意思，光是盘点就能聊一整天。", likes: 566, time: "2 小时前" },
      { user: "客观评价", content: "名单整体挺均衡的，期待最终结果别太意外。", likes: 389, time: "4 小时前" },
    ],
    related: ["new-drama-premiere", "song-cover-viral", "idol-airport-outfit"],
  },
};